import { Typography } from 'app/components/ui';
import { useState } from 'react';
import { i18n } from 'app/utils/i18n';
import { NewExtensionModal } from './NewExtensionModal/NewExtensionModal';
import { UUID } from 'app/api/tag-queries';

interface NewExtensionProps {
  documentSuperId: number;
  taxonomyId: UUID;
  /** Optional seed (e.g. when launched from a selected tag's concept). */
  widerAnchorSeed?: string | null;
}

export const NewExtension = ({ documentSuperId, taxonomyId, widerAnchorSeed }: NewExtensionProps) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <button className="tag-toolbar__button" onClick={() => setShow(true)}>
        <i className="fa-regular fa-lg fa-circle-plus" />
        <Typography variant="body-5" fontWeight="bold">
          {i18n('tag.extension.create.new')}
        </Typography>
      </button>

      <NewExtensionModal
        show={show}
        onClose={() => setShow(false)}
        documentSuperId={documentSuperId}
        taxonomyId={taxonomyId}
        widerAnchorSeed={widerAnchorSeed ?? null}
      />
    </>
  );
};
